import {create} from 'zustand';
import {UseRequestPreviewFlowStoreProps} from './types';

export const useRequestPreviewFlowStore =
	create<UseRequestPreviewFlowStoreProps>(set => ({
		useServiceTypeFormV2: false,
		setUseServiceTypeFormV2: value => set({useServiceTypeFormV2: value}),
		preselectedModality: null,
		setPreselectedModality: value => set({preselectedModality: value}),
		selectedServiceTypeOption: null,
		setSelectedServiceTypeOption: value =>
			set({selectedServiceTypeOption: value}),
		finishPreviewParams: null,
		setFinishPreviewParams: value => set({finishPreviewParams: value}),
		previewsAnalysisResult: null,
		setPreviewsAnalysisResult: value => set({previewsAnalysisResult: value}),
		isPdfDownloading: false,
		setIsPdfDownloading: value => set({isPdfDownloading: value}),
		isPdfExitWarningOpen: false,
		setIsPdfExitWarningOpen: value => set({isPdfExitWarningOpen: value}),
		resetFlow: () =>
		set({
			useServiceTypeFormV2: false,
			preselectedModality: null,
			selectedServiceTypeOption: null,
			finishPreviewParams: null,
			previewsAnalysisResult: null,
			isPdfDownloading: false,
			isPdfExitWarningOpen: false,
		}),
	}));
